import { useRef } from 'react';

const MAX_DURATION_MS = 4 * 60 * 60 * 1000; // 4 horas

// Hook para medir duracion_ms entre paso_iniciado y paso_completado.
//
// Reglas:
// - startStep(key): registra timestamp solo si es la primera vez para ese key
//   (navegar de vuelta y volver al paso NO reinicia el timer).
// - getDuration(key): retorna { duracion_ms } o { duracion_ms: null, duracion_descartada: true }
//   si la duración supera 4 horas (pestaña abierta olvidada).
// - reset(): limpia todos los timestamps (llamar al montar un módulo nuevo).

export function useStepTimer() {
  const timesRef = useRef({});

  const startStep = (key) => {
    if (key && !timesRef.current[key]) {
      timesRef.current[key] = Date.now();
    }
  };

  const getDuration = (key) => {
    const start = timesRef.current[key];
    if (!start) return {};
    const ms = Date.now() - start;
    if (ms > MAX_DURATION_MS) return { duracion_ms: null, duracion_descartada: true };
    return { duracion_ms: ms };
  };

  const reset = () => {
    timesRef.current = {};
  };

  return { startStep, getDuration, reset };
}
